import { TorusGeometry, MeshNormalMaterial } from 'three';
import InstancedShapes, { scatter } from './InstancedShapes.js';
import gsap from 'gsap';

export default class Donuts extends InstancedShapes {
    constructor(amount, repulsion) {
        super(
            new TorusGeometry(0.3, 0.2, 20, 45),
            new MeshNormalMaterial({ wireframe: true }),
            amount,
            repulsion
        );
        this.place(scatter(10, 1.75));

        gsap.from(this.positions, {
            x: Math.cos(this.isMobile ? 5.2 : 11),
            y: Math.sin(this.isMobile ? 5.2 : 11),
            z: Math.sin(this.isMobile ? 5.2 : 11),
            duration: 12.5,
            yoyo: true,
            repeat: -1,
            stagger: 0.01,
            ease: "back.inOut(1.7)",
            repeatDelay: 8,
        });
        gsap.from(this.scales, {
            x: 0.5,
            y: 0.5,
            z: 0.5,
            duration: 12.5,
            yoyo: true,
            repeat: -1,
            stagger: 0.01,
            ease: "back.inOut(1.7)",
            repeatDelay: 8,
        });
        gsap.to(this.rotations, {
            x: Math.PI * 4,
            duration: 20,
            yoyo: true,
            repeat: -1,
            ease: "power1.inOut()",
        });
    }
}
